
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as ForgeIcon } from "../fontello/icons/svg/ic_forge.svg"


const Forge = ({ ...props }) => (
  <SvgIcon
    component={ForgeIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Forge
